import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/images/new-content-login.png'
import _imports_1 from '@/images/logo-login.png'


const _withScopeId = n => (_pushScopeId("data-v-6aed9e5a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "box" }
const _hoisted_2 = {
  key: 0,
  class: "box-thumb"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  style: {"max-width":"70%"},
  src: _imports_0,
  preview: false
}, null, -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = { class: "box-content" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("section", { class: "content-header" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "header-logo" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_1,
      alt: "Acesso ao Sistema",
      preview: false
    })
  ])
], -1))
const _hoisted_7 = {
  key: 0,
  class: "content-account"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "account-header" }, [
  /*#__PURE__*/_createElementVNode("h2", null, "Informe a Senha")
], -1))
const _hoisted_9 = { class: "account-form" }
const _hoisted_10 = { class: "form-action" }
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" Alterar a Senha ")
const _hoisted_12 = {
  key: 1,
  class: "content-success"
}
const _hoisted_13 = {
  key: 2,
  class: "content-footer"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_input_password = _resolveComponent("a-input-password")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_CheckCircleFilled = _resolveComponent("CheckCircleFilled")!
  const _component_a_result = _resolveComponent("a-result")!
  const _component_Footer = _resolveComponent("Footer")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    (!_ctx.isMobile)
      ? (_openBlock(), _createElementBlock("section", _hoisted_2, _hoisted_4))
      : _createCommentVNode("", true),
    _createElementVNode("section", _hoisted_5, [
      _hoisted_6,
      (!_ctx.isSuccessActiveAccount)
        ? (_openBlock(), _createElementBlock("section", _hoisted_7, [
            _hoisted_8,
            _createElementVNode("div", _hoisted_9, [
              _createVNode(_component_a_form, {
                layout: "vertical",
                ref: "formRef",
                class: "form"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_form_item, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_input_password, {
                        value: _ctx.formAccount.password,
                        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formAccount.password) = $event)),
                        placeholder: "Senha",
                        size: "large"
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_form_item, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_input_password, {
                        value: _ctx.formAccount.rePassword,
                        "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formAccount.rePassword) = $event)),
                        placeholder: "Repetir a Senha",
                        size: "large"
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  _createElementVNode("div", _hoisted_10, [
                    _createVNode(_component_a_button, {
                      type: "primary",
                      size: "larger",
                      class: "btn-action-certificata",
                      style: {"width":"40%","max-width":"300px"},
                      onClick: _ctx.activeAccount
                    }, {
                      default: _withCtx(() => [
                        _hoisted_11
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ])
                ]),
                _: 1
              }, 512)
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.isSuccessActiveAccount)
        ? (_openBlock(), _createElementBlock("section", _hoisted_12, [
            _createVNode(_component_a_result, {
              status: "success",
              title: "Senha cadastrada com sucesso",
              "sub-title": "Você será redirecionado para a página de pagamento!",
              class: "active-account-success"
            }, {
              icon: _withCtx(() => [
                _createVNode(_component_CheckCircleFilled, { class: "success-ic" })
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true),
      (!_ctx.isMobile)
        ? (_openBlock(), _createElementBlock("section", _hoisted_13, [
            _createVNode(_component_Footer)
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}